import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { tsdaBaseQuery } from './baseQuery';

export const toolkitFormAPI = createApi({
  baseQuery: tsdaBaseQuery,
  reducerPath: 'ToolkitFormAPI',
  endpoints: builder => ({
    getConfiguredForms: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, parent_id, data }) => ({
        url: `${formatString(endPoints.toolkitFormsAPI.getConfiguredForms, {
          key: urlKeys.study_id,
          value: study_id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&parent_id=${parent_id}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'POST',
        body: data
      })
    }),
    getFormLibrary: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, published_version, OID }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.getFormLibrary,
          {
            key: urlKeys.OID,
            value: OID
          },
          {
            key: urlKeys.published_version,
            value: published_version
          }
        )}?form_type=Study Form&site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'GET'
      })
    }),
    createFormData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.createFormData
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    selecteToolkitFormData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.selectFormData
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    updateToolkitFormData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.updateFormData
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    signToolkitForm: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country, username, password, signed_reason, parent_id }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.signToolkitform,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.parent_id,
            value: parent_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&username=${username}&password=${password}&signed_reason=${signed_reason}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    completeToolkitFormData: builder.mutation<any, any>({
      query: ({ data, parent_id, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.completeToolkitform,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.parent_id,
            value: parent_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'PUT'
      })
    }),
    getPatientToolkitFormById: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, parent_id, toolkit_form_id }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.getPatientToolkitFormById,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.parent_id,
            value: parent_id
          },
          {
            key: urlKeys.toolkit_form_id,
            value: toolkit_form_id
          }
        )}?site_id=${site_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=PATIENT TRIAL NOTEBOOK`,
        method: 'GET'
      })
    })
  })
});

export const {
  useGetConfiguredFormsMutation,
  useGetFormLibraryMutation,
  useCreateFormDataMutation,
  useSelecteToolkitFormDataMutation,
  useUpdateToolkitFormDataMutation,
  useSignToolkitFormMutation,
  useCompleteToolkitFormDataMutation,
  useGetPatientToolkitFormByIdMutation
} = toolkitFormAPI;
